export enum VIEWS {
	GRID = 'grid',
	LIST = 'list'
}
